module.exports = __webpack_public_path__ + "assets/images/template/project/flu_comparison/tablet.svg?v=6b74a750";